import { render, staticRenderFns } from "./AlgerianPriceReader.vue?vue&type=template&id=29adb470&scoped=true"
import script from "./AlgerianPriceReader.vue?vue&type=script&lang=js"
export * from "./AlgerianPriceReader.vue?vue&type=script&lang=js"
import style0 from "./AlgerianPriceReader.vue?vue&type=style&index=0&id=29adb470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adb470",
  null
  
)

export default component.exports